import { useTheme } from '@mui/material/styles';

export const useStyles = () => {
  const theme = useTheme();
  return {
    button: {
      borderRadius: '40px',
      textTransform: 'initial',
      borderWidth: '2px',
      fontWeight: 600,
      boxShadow: 'none',
      display: 'inline-block',
      '& > .MuiButton-label': {
        display: 'inline-block',
        verticalAlign: 'sub',
      },
      '&:hover': {
        borderWidth: '2px',
      },
    },
    optButton: {
      width: '100%',
      textTransform: 'none',
    },
  };
};
